<template>
  <Form :layout="props.fromLayout" :label-col="labelCol" :wrapper-col="wrapperCol" ref="formRef" :model="formState">
    <div style="display: flex; flex-wrap: wrap">
      <div
        v-for="(i, k) in formOption.value"
        :key="`${i.prop}-${k}`"
        :style="`width: ${i.formWidth || i.width || props.formItemWidth};margin-right:15px;`"
      >
        <FormItem :name="i.prop" :label="i.label + ':'" :rules="i.rules">
          <component
            :key="formKey"
            :type="i.type"
            style="width: 100%"
            :is="getComponent(i.type)"
            v-model:value="formState[i.prop]"
            :placeholder="i.placeholder || lang('请输入')"
            :disabled="i.disabled"
            :dicData="i.dicData"
            :options="i.dicData"
            v-bind="i"
          />
        </FormItem>
      </div>
    </div>
  </Form>
</template>

<script lang="tsx" setup name="SmartForm">
import { inject, isRef, onMounted, reactive, ref, watchEffect } from 'vue'
import { Form, FormItem } from 'ant-design-vue'
import { filterFormOption } from '../smart-crud/utils'
import { getComponent } from '../utils/tools'
const lang = inject('lang')
const formKey = ref(Date.now())

const props = defineProps({
  option: {
    type: Object,
    required: true
  },
  fromLayout: {
    type: String,
    default: 'horizontal'
  },
  formItemWidth: {
    type: String,
    default: '100%'
  }
  // form: {
  //   type: Object,
  //   default: () => ({})
  // }
})

const emit = defineEmits(['success'])
const formState = ref({})
// const formState = defineModel('form', {
//   type: Object,
//   default: () => ref({})
// })

console.log('formState', isRef(formState))

const formRef = ref()
const modalType = ref('create')
const labelCol = ref({ span: 24 })
const wrapperCol = ref({ span: 24 })
const modalWidth = ref('800px')

if (props.option.modalWidth) {
  modalWidth.value = props.option.modalWidth
}

const formOption = reactive<{ value: Record<any, any>[] }>({ value: [] })

// const formRules = reactive<Record<any, any>>({})

watchEffect(() => {
  const sfo = filterFormOption(props.option.column, lang) as Record<any, any>[]
  // 每次option发生变化重置表单
  formKey.value = Date.now()
  if (modalType.value === 'update') {
    formOption.value = sfo
      .filter((i: Record<any, any>) => i.editDisplay !== false)
      .map((i) => ({ disabled: i.editDisabled, ...i })) as Record<any, any>[]
  }
  if (modalType.value === 'create') {
    formOption.value = sfo
      .filter((i: Record<any, any>) => i.addDisplay !== false)
      .map((i) => ({ disabled: i.addDisabled, ...i })) as Record<any, any>[]
  }
})

const init = () => {
  const sfo = filterFormOption(props.option.column, lang) as Record<any, any>[]

  sfo.forEach((i) => {
    // if (i.rules && i.rules.length > 0) {
    //   formRules[i.prop] = i.rules
    // }
    if (i.valueDefault !== undefined) {
      formState.value[i.prop] = i.valueDefault
    }
  })
}

onMounted(() => {
  init()
})

defineExpose({
  resetForm: () => {
    formRef.value.resetFields()
  },
  formState,
  validateFields: () => formRef.value.validateFields(),
  resetFields: (nameList?: string[]) => formRef.value.resetFields(nameList),
  setFieldValue: (fidle: string, value: any) => {
    formState.value[fidle] = value
  }
})
</script>
